module.exports = __webpack_public_path__ + "img/connection-right-1.7cd5e6b3.png";